import ButtonAdmin from './ButtonAdmin'

export default ButtonAdmin
// eslint-disable-next-line import/export
export * from './ButtonAdmin'
